import $ from 'jquery'
import _ from 'lodash'
import moment from 'moment-timezone'

import api from '@/api/api'

import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import DateField from '@/components/general/fields/date/date'
import SearchField from '@/components/general/fields/search/search'
import FileField from '@/components/general/fields/file/file'

export default {
  name: 'history-sda',
  data () {
    return {
      SDAsInfo: [],
      menuOptions: [
        {
          iconClass: 'fa fa-archive',
          name: this.$t('private.history.sda.menu_more_options.archive_contract'),
          action: 'archive'
        }
      ],
      filters: {
        since: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.since'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        until: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.until'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        exported: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
          value: 'all',
          name: this.$t('private.reports.sda.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
            value: 'all'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.only_exported'),
            value: 'only_exported'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.not_exported'),
            value: 'not_exported'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.limit_options.50'),
          value: 50,
          name: this.$t('private.reports.sda.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: 10,
            value: 10
          }, {
            fakeValue: 25,
            value: 25
          }, {
            fakeValue: 50,
            value: 50
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        seller: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.seller'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        delegation: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.delegation'),
          error: false,
          active: false,
          options: [],
          style: {
            width: '120px',
            marginTop: '0px'
          }
        },
        clientCode: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.client_code'),
          type: 'text',
          error: false,
          style: {
            width: '150px',
            marginTop: '0px'
          }
        },
        legalName: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        skip: {
          value: 0
        }
      },
      getSDAsInfoActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      displayFoo: false
    }
  },
  methods: {
    rowClicked (element, value) {
      element.rowSelected = value

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true
    },
    getSDAsInfo () {
      let vm = this

      vm.getSDAsInfoActive = true
      vm.SDAsInfo = []

      let exported = vm.filters.exported.value === 'all' ? '' : vm.filters.exported.value === 'only_exported'

      let since = vm.filters.since.value ? moment(vm.filters.since.value).startOf('day').toDate() : ''
      let until = vm.filters.until.value ? moment(vm.filters.until.value).endOf('day').toDate() : ''

      let dataToSend = {
        className: 'SDAsInfoHistory',
        limit: (vm.filters.limit.value + 1),
        skip: vm.filters.skip.value,
        descending: 'lastDateSDA',
        since,
        until,
        exported,
        seller: vm.filters.seller.value,
        delegation: vm.filters.delegation.value,
        clientCode: vm.filters.clientCode.value,
        legalName: vm.filters.legalName.value
      }

      api
        .contractsHistory
        .getContractsSDAHistory(dataToSend)
        .then((response) => {
          vm.getSDAsInfoActive = false

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.SDAsInfo = response.data.contracts
          vm.totalContracts = response.data.countContracts

          if (vm.SDAsInfo.length > 0 && !vm.haveData) {
            vm.haveData = true
          }

          if (vm.SDAsInfo.length > vm.filters.limit.value) {
            vm.nextPage = true
            vm.SDAsInfo.pop()
          } else {
            vm.nextPage = false
          }
        })
    },
    goToBackPage () {
      let vm = this

      if (vm.filters.skip.value !== 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

        vm.getSDAsInfo()
      }
    },
    goToNextPage () {
      let vm = this

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

        vm.getSDAsInfo()
      }
    },
    searchClients (data) {
      let vm = this

      vm.getSearchClients = true

      let dataToSend = '?clientCode=' + data

      api
        .clients
        .getClients(dataToSend)
        .then((response) => {
          vm.getSearchClients = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let clients = response.data.clients

          clients = _.map(clients, (client) => {
            return {
              fakeValue: client.legalName + ' (' + client.clientCode + ')',
              value: client
            }
          })

          vm.createContractWindow.form.fields.client.options = clients
        })
    },
    optionSelected (data) {
      let vm = this

      if (data.action === 'delete') {
        vm.archiveContract(data.element)
      }
    },
    parseDate (date) {
      let _date = _.has(date, 'iso') ? date.iso : date

      return moment(_date).format('DD-MM-YYYY')
    },
    getDelegations () {
      let vm = this

      vm.getDelegationsActive = true

      let dataToSend = '/?descending=createdAt'

      api
        .delegations
        .getDelegations(dataToSend)
        .then((response) => {
          vm.getDelegationsActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let delegations = response.data.delegations

          delegations = _.map(delegations, (delegation) => {
            return {
              fakeValue: delegation.name,
              value: delegation.id
            }
          })

          vm.filters.delegation.options = delegations
        })
    },
  },
  components: {
    MenuMoreOptions,
    TextField,
    SelectField,
    CheckboxField,
    DateField,
    SearchField,
    FileField
  },
  created () {
    let vm = this
    vm.getDelegations()
    vm.getSDAsInfo()
  },
  mounted () {
    let vm = this
  }
}



// WEBPACK FOOTER //
// ./src/components/private/history/sda/script.js